import { Component, OnInit } from '@angular/core';
import { CasesService } from '../cases/cases.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { error, log } from 'console';
import { Station } from '../models/station';
import { Subscriber } from 'rxjs';
import { CdkAccordion } from '@angular/cdk/accordion';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';


@Component({
  selector: 'app-production-cases',
  templateUrl: './production-cases.component.html',
  styleUrls: ['./production-cases.component.css']
})
export class ProductionCasesComponent implements OnInit {
  url: any;
  userDetails: any;
  constructor(private _caseservice: CasesService, private Location: Location,private spinner: NgxSpinnerService, private toastr: ToastrService, private changeDetectorRef: ChangeDetectorRef,) {
    this.url = this._caseservice.CountryPhotoUrl;
  }
  productionStations: any[] = [];
  caseDetails: any[] = [];
  totalCases: number = 0;
  dragError: string | null = null;

  ngOnInit() {
    const userid = localStorage.getItem('userid');
    this.userDetails = JSON.parse(localStorage.getItem('UserDetails'));
    let RoleId = this.userDetails.roleId;
    if (userid && RoleId) {
      this.GetProductionDasboardStations(userid, RoleId);
    }
    else {
      console.error('userid and role id not found in local storage');
    }
  }
  toggleVisibility(stationName: string) {
    const station = this.productionStations.find(station => station.name === stationName);
    if (station) {
      station.visible = !station.visible;
    }
  }
  GetProductionDasboardStations(userid: string, RoleId: number) {
    debugger;
    this._caseservice.GetProductionDasboardStations(userid, RoleId).subscribe(
      (data: any) => {
        this.productionStations = data.map((station, index) => ({
          order: index + 1,
          name: station.stationName,
          stationid: station.stationId,
          data: [],
          caseCount: 0,
          visible: true
        }));
        this._caseservice.getCasDetails().subscribe(
          (casedetailsData: any) => {
            console.log('all details', casedetailsData);
            this.caseDetails = casedetailsData;
            this.caseDetails.forEach((casedata: any) => {
              if (casedata.caseStatus === 1 && casedata.shippingStatus === 2) {
                const station = this.productionStations.find(
                  (station) => station.stationid === casedata.movedStationID
                );
                if (station) {
                  station.data.push(casedata);
                  station.caseCount = station.data.length;
                }
              }
            });
              // After data is fetched and updated, trigger change detection
              this.changeDetectorRef.detectChanges();
          },
          (error) => {
            console.error('Error fetching case details:', error);
          }
        );
      },
      (error) => {
        console.error('Error fetching dashboard data:', error);
      }
    );
  }
  onCaseDropped(event: CdkDragDrop<any[]>, station: any) {
    this.dragError = null;
    const droppedCase = event.previousContainer.data[event.previousIndex];
    
    if (!droppedCase.stationIds.split(',').map(id => parseInt(id.trim(), 10)).includes(station.stationid)) {
      this.dragError = `Case cannot be moved to "${station.name}" as the workflow does not allow it.`;
      this.toastr.warning("No Access");
      return;
    }
    
    const updatedWorkflow = {
      productId: droppedCase.productId,
      orderid: droppedCase.orderId, 
      targetStationId: station.stationid,
      teethRUsUserId: droppedCase.teethRUsUserId,
    };
    
    this._caseservice.moveCaseToAnotherStation(updatedWorkflow).subscribe(
      (response: any) => {
        if (response === 1) {
          if (event.previousContainer !== event.container) {
            transferArrayItem(
              event.previousContainer.data,
              event.container.data,
              event.previousIndex,
              event.currentIndex
            );
            station.caseCount = event.container.data.length;
            const previousStation = this.productionStations.find(
              (s) => s.stationid === droppedCase.stationId
            );
            if (previousStation) {
              previousStation.caseCount = event.previousContainer.data.length;
            }
            droppedCase.stationId = station.stationid;
            this.toastr.success('Case successfully moved to "' + station.name + '"');
            this.changeDetectorRef.detectChanges();
            this.refreshData();
          }
        } else {
          this.dragError = 'Error: ' + response;
          this.toastr.warning("No Access");
        }
      },
      (error) => {
        console.error('Error moving case:', error);
        this.toastr.warning("Error moving case");
      }
    );
  }
  refreshData() {
    // Directly fetch and update production stations and case details
    const userid = localStorage.getItem('userid');
    const RoleId = this.userDetails.roleId;
    if (userid && RoleId) {
      this.GetProductionDasboardStations(userid, RoleId); // Reload data after move
    }
  }
}













